module.exports = __webpack_public_path__ + "media/theme/sp__banner-9ca65d92.png";